<script>
import SupplierJournalCategoryForm from "./Form.vue";

export default {
    name: "SupplierJournalCategoryList",

    data() {

        return {
          adjustmentTypes: [],
        };
    },

    components: {

        SupplierJournalCategoryForm
    },
}
</script>
<template>
<tail-base-layout>
  <template v-slot:breadcrum>
      <div class="bg-blue-800 p-tiny text-xs text-white rounded">
         <nav class="bg-grey-light rounded font-sans w-full p-tiny">
           <ol class="list-reset flex text-grey-dark">
             <li>
                <router-link :to="{name : `master-data.accounts.index` }">Accounts master data</router-link>
             </li>
             <li><span class="mx-2">/</span></li>
             <li>Supplier Journal Categories</li>
           </ol>
         </nav>
      </div>
  </template>
  <template v-slot:content>
      <tail-card>
        <template v-slot:card-header>
          <h5 class="text-xs font-medium">Supplier Journal Categories</h5>
        </template>
        <template v-slot:card-body>
            <SupplierJournalCategoryForm/>
            <div class="w-full overflow-auto">
              <tail-datatable :rows="[]" :columns="columns" :loading="false"></tail-datatable>
              <table class="table table-hover">
                <thead class="bg-blue-500 text-white text-xs">
                  <tr class="w-full flex">
                    <th class="p-tiny w-1/6">Code</th>
                    <th class="p-tiny w-1/3">Type</th>
                    <th class="p-tiny w-1/6">Increments</th>
                    <th class="p-tiny w-1/6">Decrements</th>
                    <th class="p-tiny w-1/12">Active</th>
                    <th class="p-tiny w-1/12">Action</th>
                  </tr>
                </thead>
                <tbody class="bg-gray-100 text-xs flex flex-col items-center overflow-auto" style="height:65vh;">
                  <tr class="w-full flex" v-for="(type,idx) in adjustmentTypes" :key="idx">
                    <td class="w-1/6 p-tiny"></td>
                    <td class="w-1/3 p-tiny"></td>
                    <td class="w-1/6 p-tiny"></td>
                    <td class="w-1/6 p-tiny"></td>
                    <td class="w-1/12 p-tiny"></td>
                    <td class="w-1/12 p-tiny"></td>
                  </tr>
                </tbody>
              </table>
            </div>
        </template>
      </tail-card>
  </template>
</tail-base-layout>
</template>
